import { useContext, useEffect } from 'react';
import {
	TextField,
	Grid,
	Checkbox,
	Button,
	Box,
	Typography,
	Divider,
	FormControlLabel,
} from '@mui/material';
import { multiStepContext } from '../../../../../hooks/StepContext';

export const Step4 = () => {

	const { setStep, firstUser, setFirstUser } = useContext(multiStepContext);

	useEffect(() => {
		setFirstUser({
			...firstUser,
			text_dados_personales: `Con el registro de la información autorizo  libre, expresa e inequívocamente a la SECRETARÍA DISTRITAL DE DESARROLLO ECONÓMICO – SDDE, como responsable para que realice la recolección y tratamiento de mis datos personales suministrados de manera veraz y completa, los cuales serán tratados con las finalidades descritas a continuación y las establecidas en la política de tratamiento de datos personales

			- Que me ha sido informada la(s) finalidad(es) de la recolección de los datos personales, la(s) cual(es) consiste(n) en: (i) Permitir que los oferentes de empleos y  candidatos realicen la creación de una cuenta en el portal web de Bogotá Trabaja; (ii) Posibilitar el contacto con los oferentes de empleo mediante la aplicación a ofertas de empleo publicadas por los mismos en el portal; (iii) Permitir a los oferentes de empleo la publicación y gestión de ofertas laborales en portal web Bogotá Trabaja; (iv) Permitir a los candidatos registrar, elaborar y modificar sus hoja de vidas; (v) Desarrollo de actividades de validación de la información publicada en portal de Bogotá Trabaja; (vi) Permitir a los oferentes de empleo la consulta de hojas de vida en la base de datos; (vii) Permitir la realización de pruebas para la identificación de afinidades para una oferta laboral publicada en el portal Bogotá Trabaja; (viii) Transmitir y/o transferir los datos personales con la Agencia de Analítica de Datos S.A.S. y a los aliados y proveedores de esta, para  el cumplimiento de funciones públicas de la Agencia asociadas a su objeto social, principalmente, para generar Data Analítica y Metadata que permitan cumplir con los Casos de uso para la toma de decisiones de Política Pública de Alcaldía Mayor de Bogotá. (ix) Transmitir y/o transferir los datos personales con entidades públicas, aliados y/o proveedores vinculadas para el desarrollo de actividades, políticas públicas o desarrollo de contratos, convenios o alianzas y en general para el desarrollo de cualquier actividad que SDDE adelante en forma conjunta con ellos, en el marco de sus funciones; (x)Transmitir y/o transferir los datos personales con aliados y/o proveedores para el correcto funcianmiento del portal web Bogotá Trabaja; (xi) Efectuar las gestiones y dar cumplimiento al desarrollo de los objetivos misionales de la Entidad, en lo que tiene que ver las políticas públicas del Sector de Desarrollo Económico para la ciudad de Bogotá D.C. en coordinación con entidades y actores aliados; (xii) Formular e implementar políticas públicas.; (xiii) Facilitar la implementación y materialización de programas en cumplimiento de mandatos legales; (xiv) Gestionar trámites (peticiones, solicitudes, quejas, reclamos); (xv) Efectuar encuestas de satisfacción de los servicios ofrecidos por la SDDE; (xvi) Suministrar información de contacto a cualquier tercero con el cual la Secretaría Distrital de Desarrollo Económico, tenga un vínculo contractual para el desarrollo de actividades misionales o de apoyo; (xvii) Contactar al titular para realizar confirmación de datos personales, necesarios para la prestación de los servicios de la SDDE y del portal web Bogotá Trabaja; (xviii) Contactar al titular para el envío de información de interés relacionada con la prestación del servicio; (xix) Identificar población objeto de atención por parte de la SDDE; (xx) Promover la inclusión de la población objeto de atención por parte de la SDDE;  (xxi) Realizar invitaciones para estudios de mercado de proveedores.

			- Manifiesto que he leído y conozco la Política de Tratamiento y Protección de Datos Personales publicada en www.desarrolloeconomico.gov.co, declarando que he sido informado-(a) de la posibilidad que tengo de no entregar la información considerada sensible.

			- Declaro que como titular de la información, fui informado de los derechos con que cuento como titular de la información, especialmente a conocer, actualizar y rectificar mi información personal, revocar la autorización y solicitar la supresión del dato, las cuales podré ejercer a través de los canales presenciales con el personal de Atención al Usuario, el correo electrónico: pqrsd@desarrolloeconomico.gov.co, y en la línea de teléfono: en Bogotá (601) 369 37 77 Ext: 100."`,
		});
	}, []);

	const handleNext = async () => {
		if (firstUser.user['dados_personales'] === true || firstUser.user['dados_personales'] === false) {
			setStep(5);
		}
	};

	return (
		<>
			<Grid
				container
				direction='row'
				justifyContent='space-between'
				width={'100%'}
				sx={{
					backgroundColor: '#1C447F',
					pt: 2,
					pl: 2,
					pb: 2,
					pr: 2,
					borderTopLeftRadius: 6,
					borderTopRightRadius: 6,
				}}
				item={true}
			>
				<Grid container direction='column' item={true}>
					<Typography color='white' variant='h5'>
						Tratamiento de datos personales
					</Typography>
				</Grid>

				<Box display='flex' justifyContent='end' alignItems='center'></Box>
			</Grid>

			<Grid xs={12} mb={5} item={true}>
				<TextField
					fullWidth
					required
					id='text_dados_personales'
					name='text_dados_personales'
					value={firstUser['text_dados_personales']}
					disabled={true}
					multiline
					rows={15}
				/>
			</Grid>
			<Grid
				xs={12}
				mb={3}
				display='flex'
				justifyContent='space-between'
				alignItems='center'
				item={true}
			>
				<FormControlLabel
					value='dados_personales'
					control={
						<Checkbox
							color='default'
							checked={firstUser.user['dados_personales']}
							value={firstUser.user['dados_personales']}
							onChange={(e) =>
								setFirstUser({
									...firstUser,
									user: { ...firstUser.user, dados_personales: e.target.checked },
								})
							}
						/>
					}
					label='Acepto la política de privacidad de datos'
					labelPlacement='end'
				/>
			</Grid>
			<Divider sx={{ border: 1, borderColor: '#B0B0B0', mb: 1 }} />
			<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', pt: 2 }}>
				<Button
					variant='contained'
					sx={{ background: '#0A4396', mr: 1, width: 90 }}
					onClick={() => setStep(3)}
				>
					Atrás
				</Button>
				<Button
					variant='contained'
					sx={{ mr: 1, width: 90, height: 40 }}
					onClick={() => handleNext()}
					disabled={!firstUser.user['dados_personales']}
				>
					Siguiente
				</Button>
			</Box>
		</>
	);
};
